import React from 'react'

export default function Cancelled({cancelled, onCancelled}) {
  return <div id='cancelled-game-button'>
    <label>
      <input 
        type='checkbox' 
        value={cancelled}
        onChange={(event) => onCancelled(event.target.checked)}
      />
      <span>Cancelled Games</span>
    </label>
  </div>
}
